export default "__VITE_ASSET__730ea141__"